// Flow Builder Main Entry Point
import './flow-builder';
import './node-manager';
import './flow-sync';

// Export for global access if needed
window.FlowBuilder = {
    init: function(element, options = {}) {
        // Will be initialized from flow-builder.js
        console.log('FlowBuilder initialized');
    }
};